import { Transition } from "@headlessui/react";
import React from "react";
import Error from "../../common/components/error";
import Loading from "../../common/components/loading";
import { useFeatureFlagsQuery } from "../../graphql/generated";
import FeatureFlagActions from "../components/actions";
import FeatureFlagCard from "../components/card";
import { useTitle } from "../../common/utils/title";

const FeatureFlagList: React.FC = () => {
  useTitle("Feature Flags");
  const [{ data, error, fetching }] = useFeatureFlagsQuery({
    requestPolicy: "cache-and-network",
  });

  return (
    <>
      <Loading show={!data && !error} />
      <Error error={error} />
      <Transition
        show={!!data}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-4">
          <div className="sm:flex sm:items-center sm:justify-between">
            <div className="flex-1 min-w-0">
              <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
                FeatureFlags
                <span className="text-sm text-gray-500 px-2">
                  {fetching ? "Loading..." : `${data?.featureFlags.length}`}
                </span>
              </h2>
            </div>
            <div className="mt-5 flex sm:mt-0 sm:mr-4">
              <FeatureFlagActions />
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-4">
          <div className="bg-white shadow overflow-hidden sm:rounded-md">
            <div className="p-4">
              <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                {data?.featureFlags.map((flag) => (
                  <FeatureFlagCard flag={flag} key={flag.id} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </Transition>
    </>
  );
};

export default FeatureFlagList;
